<template>
    <div class="convention-body">
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
        <typo :name="typoName || 'cc-body'" v-html="body"></typo>
    </div>
</template>

<script>
import Vue from "vue";

import contentBody from "src/mixins/contentBody";

export default Vue.extend({
    props: ["body", "mode", "typoName"],
    mixins: [contentBody],
    mounted() {
        this.filterContent();
    },
    updated() {
        this.filterContent();
    },
    methods: {
        filterContent() {
            this.normalizeTitles();
            this.normalizeArticleLinks();
            this.normalizeArticlesCategoryLinks();
            this.normalizeCCNLinks(this.mode);
            this.normalizeLinkedContentsLinks();
            this.normalizeTable();
            this.normalizeDocumentLinks();
        },
    },
});
</script>

<style lang="sass">

.convention-body
    color: $color-secondary

    ul
        margin: 10px 0 20px 0
        li
            margin: 8px 0

    table
        width: 100%
        margin: 16px 0 16px 0
        border-collapse: collapse
        border-radius: 5px
        display: table
        th
            background: $color-yellow
            color: $color-secondary
            padding: 5px 10px
            border: 1px solid transparentize($color-secondary, 0.4)
        td
            border: 1px solid transparentize($color-secondary, 0.4)
            padding: 5px

    .cc-article
        display: block
        position: relative
        text-align: left
        background: $color-background
        padding: $grid-gutter
        align-items: center
        margin: 16px 0
        padding: 25px 16px 25px 80px
        box-sizing: border-box
        &:before
            top: calc(50% - 25px)
            left: 20px
            position: absolute
            display: block
            content: ''
            width: 50px
            height: 50px
            background: url(./article.svg) no-repeat
            background-size: contain
            background-position: center

    .cc-inside-h2
        display: block
        position: relative
        margin: 50px 0 30px 0
        padding-bottom: 10px
        &:before
            position: absolute
            width: 50px
            bottom: 0
            content: ""
            height: 1px
            background: $color-secondary

    .cc-inside-h1
        display: block
        position: relative
        margin: 20px 0 30px 0
        padding-bottom: 10px

    .cc-inside-h3
        display: block
        margin: 30px 0 15px 0
        font-size: 18px
        margin: 16px 0
    .cc-inside-h4
        display: block
        margin: 30px 0 10px 0
        font-size: 16px
        margin: 16px 0
    .cc-inside-h5
        display: block
        margin: 30px 0 5px 0
        font-size: 14px
        margin: 16px 0
@media print
    .convention-body
        a
            color: #4a7ab8 !important
            font-weight: 500
            text-decoration: underline

        .cc-article
            background-color: transparent
            padding: 0 0 0 14mm
            margin: 3mm 0 4mm 0
            min-height: 10mm
            break-inside: avoid

            &:before
                top: calc(50% - 5mm)
                left: 0
                width: 10mm
                height: 10mm

        .cc-body
            display: block
            margin-left: 7.5mm
            p
                break-inside: avoid
            li
                break-inside: avoid
</style>
